import React, { useEffect, useRef } from "react";
import LoadingBar from "react-top-loading-bar";
import { useLoad } from "../../context/Load";

export default function Load() {
  const { load, setLoad } = useLoad();

  const ref = useRef(null);

  useEffect(() => {
    if (load === true) {
      ref.current.continuousStart();
    }
    if (load === false) {
      ref.current.complete();
    }
  }, [load]);

  return (
    <div style={{ marginLeft: -20 }}>
      <LoadingBar color="#f8a602" ref={ref} shadow={false} height={5} />
    </div>
  );
}
